// extracted by mini-css-extract-plugin
export default {"logoutBtn":"LogoutBtn_logoutBtn__Wvahz","logoutIcon":"LogoutBtn_logoutIcon__MNyxQ"};